// this file added by Bearer Web Developer
import React from "react";
import { useThemeMode } from "../../states/contexts/theme";

const HamburgerMenu: React.FC = () => {
    const { theme } = useThemeMode();
    return (
        <>
            {
                theme === "dark" ? <img src="/hamburger-menu-dark.svg" alt="" /> :
                    <img src="/hamburger-menu.png" alt="" />
            }
        </>
    )
}
export default HamburgerMenu;